import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../hooks/hooks';
import PageLoader from '../../../../../components/PageLoader';
import { selectDbasListItems } from '../../../../../redux/dbas/selector';
import { dbas } from '../../../../../redux/dbas/action';
import * as R from "ramda"
import { selectGatewaysQueryFQDNStatus, selectGatewaysQueryItems, selectGatewaysReadKeys, } from '../../../../../redux/gateways/selector';
import { gateways } from '../../../../../redux/gateways/action';
import { selectTenantOpennetworkDomainsListItems } from '../../../../../redux/tenant-open-network-domains/selector';
import { selectNetworksListItems } from '../../../../../redux/dbaas/networks/selector';
import { networks } from '../../../../../redux/dbaas/networks/action';
import { tenantOpenNetworkDomains } from '../../../../../redux/tenant-open-network-domains/action';
import GatewayComponent from '../components/gateway/gateway.component';
import { selectWebsitesListItems } from '../../../../../redux/websites/selector';
import { websites } from '../../../../../redux/websites/action';
import storePersist from '../../../../../redux/storePersist';
import { useConfirm } from '../../../../../hooks/useConfirm';

const Gateway = () => {
  var tenantId = storePersist?.get("guestTokenMetadata")?.current?.result?.TokenMetadata?.TenantId;
  //  const accessTokenMetadata = storePersist.get('accessTokenMetadata').current?.TokenMetadata;
  const { confirm, modal } = useConfirm();

  const websitesItems = useSelector(selectWebsitesListItems)
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const queryItems = useSelector(selectGatewaysQueryItems)
  const domainItems = useSelector(selectTenantOpennetworkDomainsListItems)
  const NetworkItems = useSelector(selectNetworksListItems)
  const dbasItems = useSelector(selectDbasListItems)
  const fqdnStatus = useSelector(selectGatewaysQueryFQDNStatus)
  const ondcKeys = useSelector(selectGatewaysReadKeys)
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const [
    selectedGateway,
    setSelectedGateway
  ] = useState<any>([])

  const fetchGatewayById = () => {
    dispatch(gateways.query({
      url: `https://edgegateway.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/dbn-cloud/gateways/fetch-detail`, entity: 'gateways', jsonData: {
        Context: {},
        Records: [
          {
            "GatewayId": parmas?.id
          }
        ]
      }
    })).then(() => {
      setIsQuery(true)
    })
  }


  const regenerateKeys = async () => {
    await dispatch(gateways.readKeys({
      url: `https://edgegateway.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/key-generator/key-generate`, entity: 'gateways'
    }))
  }

  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectedGateway({ ...selectedGateway, [field]: event });
  }

  const handleFormChange: any = (event: any, field: string, data: any) => {
    const fields = R.split(
      '.',
      field
    );
    const value = { ...data, [fields[1]]: event }// inner data update
    setSelectedGateway({ ...selectedGateway, [fields[0]]: value });
  }

  useEffect(
    () => {
      dispatch(networks.list({
        url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dbaas/networks/list`,
        entity: 'networks',
        jsonData: {}
      })).then(() => {
        dispatch(tenantOpenNetworkDomains.list({
          url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/platform-management/domains/list`,
          entity: 'tenantOpenNetworkDomains',
          jsonData: {}
        })).then(() => {
          dispatch(dbas.list({
            url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dbn-cloud/dbas/list`,
            entity: 'dbas',
            jsonData: {
            }
          }))
        })
          .then(() => {
            dispatch(websites.list({
              url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/tenant-websites/list`, entity: 'cards', jsonData: {
                "Filters": [
                  {
                    "FieldName": "TenantId",
                    "FilterOperatorId": 1,
                    "FieldValue": tenantId,
                    "FieldType": "number"
                  }
                ],
              }
            }))
          })
        if (parmas?.id > 0) {
          fetchGatewayById()
        }
      })
    },
    []
  )
  useEffect(
    () => {
      if (isQuery) {
        setSelectedGateway(queryItems?.result?.items)
      }
    },
    [isQuery]
  )

  const handleRegenerateKeys = async () => {
    const confirmation = confirm("Are you sure to regenerate the keys?");
    if (confirmation) {
      await regenerateKeys();      
    }
  }

  useEffect(() => {
    console.log('ondcKeys', ondcKeys)
    const keys = ondcKeys?.result;
      if (keys) {
        const data = {
          ...selectedGateway,
          SigningPrivateKey: keys.B64Ed25519SigningPrivateKeyBC,
          SigningPublicKey: keys.B64Ed25519SigningPublicKeyBC,
          EncrPrivateKey: keys.B64X25519EncryptionPrivateKeyBC,
          EncrPublicKey: keys.B64X25519EncryptionPublicKeyBC,
          UniqueId: selectedGateway?.isChangeUniqueKey? keys["UUID_Unique Request ID"] : selectedGateway?.UniqueId
        }
        setSelectedGateway(
          data
        )
      }
  }, [ondcKeys]);

  useEffect(() => {
    console.log('selectedGateway', selectedGateway)
  }, [selectedGateway]);

  const handleFQDNStatusCheck = async (domain: string) => {
    try {
      checkFQDNStatus(domain);
    } catch (e: any) {
      console.log('unable to check status', e.message)
    }

  }


  const checkFQDNStatus = async (domain: string) => {
    await dispatch(gateways.fqdnCheck({
      url: `https://${domain}/check-fqdn`, entity: 'dbass', jsonData: {
        domain: domain
      }
    }))
  }

  const updateGateway = async () => {
    await dispatch(gateways.resetAction({ actionType: 'update' }))
    await dispatch(gateways.update({
      url: `https://edgegateway.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/dbn-cloud/gateways`, entity: 'dbass', jsonData: {
        Context: {},
        Records: [
          {
            ...selectedGateway,
            Cities: selectedGateway?.IsLimitedToCities ? selectedGateway?.Cities : ['*']
          }
        ]
      }
    }))
  }

  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
    if (parmas?.id > 0) {
      await updateGateway();
      back();
    } else {
      await dispatch(gateways.resetAction({ actionType: 'create' }))
      await dispatch(gateways.create({
        url: `https://edgegateway.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/dbn-cloud/gateways`, entity: 'dbass', jsonData: {
          Context: {},
          Records: [
            {
              ...selectedGateway,
              Cities: selectedGateway?.IsLimitedToCities ? selectedGateway?.Cities : ['*']
            }]
        }
      })).then(() => {
        back()
      })
    }
  }

  const back = () => {
    navigate('/management/dbn-cloud/gateways')
  }

  useEffect(() => {
    console.log('fqdnStatus', fqdnStatus)
  }, [fqdnStatus]);


  return (
    <>
      {modal}
      {domainItems?.isLoading || NetworkItems?.isLoading || dbasItems?.isLoading ? <PageLoader /> :
        <GatewayComponent
          handleInnerFormChange={handleInnerFormChange}
          selectedGateway={selectedGateway}
          domainDetails={domainItems?.result?.items}
          networks={NetworkItems?.result?.items}
          back={back}
          handleFormSubmit={handleFormSubmit}
          handleFormChange={handleFormChange}
          dbas={dbasItems?.result?.items}
          checkFQDNStatus={handleFQDNStatusCheck}
          regenerateKeys={handleRegenerateKeys}
          websites={websitesItems?.result?.items}
        />
      }
    </>
  )

}

export default Gateway;
